export default function getPastMonth() {
  const date: Date = new Date();
  date.setDate(1);
  date.setMonth(date.getMonth() - 1);
  return new Date(date).toISOString().substr(0, 7);
}
